import React from "react";
import Hero from "components/hero";

const PageContainer = ({
  className,
  title,
  subtitle,
  children,
  headerComponent,
}) => {
  const classes = ["page", className];

  let content;

  if (headerComponent) {
    content = headerComponent;
  } else if (title && subtitle) {
    content = (
      <div>
        <h1 className="title">{title}</h1>
        <h2 className="subtitle"> {subtitle}</h2>
      </div>
    );
  }

  return (
    <div className={classes.join(" ")}>
      <Hero />
      <div className="section main">
        <div className="has-text-centered">
          {content}
          <hr />
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContainer;



// WEBPACK FOOTER //
// ./src/pages/container/page-container.js